import { useSelector } from 'react-redux';

import CheckoutSummary from 'organisms/CheckoutSummary';
import { isEmpty, prettifyDate } from 'util';

export default function SummaryInfo({ appointmentObj }) {
  const storedAppointment = useSelector((state) => state.appointment);

  const appointment = appointmentObj || storedAppointment;
  const { actions, dateStart, isLoading, service, summary, payment } =
    appointment;

  if (!summary || isEmpty(summary)) return null;

  return (
    <div className="summary-info flex-column mb-12 p-24 border-light-purple radius-24">
      <h4 className="mb-8">{service.name ?? 'Service summary'}</h4>
      {!!dateStart && (
        <p className="flex-row mb-15 f13">{prettifyDate(dateStart)}</p>
      )}
      <CheckoutSummary
        actions={actions}
        isLoading={isLoading}
        payment={payment}
        service={service}
        summary={summary}
      />
    </div>
  );
}
